import { lazy, Suspense, ReactNode, ComponentType } from 'react';

export default function loadable(
  importFunc: () => Promise<{ default: ComponentType<any> }>,
  { fallback = null }: { fallback: ReactNode } = { fallback: null },
) {
  const LazyComponent = lazy(importFunc);
  function Component(props: any) {
    return (
      <Suspense fallback={fallback}>
        <LazyComponent {...props} />
      </Suspense>
    );
  }
  return Component;
}
